import React from 'react';
import { motion } from 'framer-motion';
export function Booking() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-295">
      <div className="max-w-2xl mx-auto" data-id="element-296">
        <header className="mb-16 text-center" data-id="element-297">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-298">
            Bespoke Experience
          </span>
          <h1 className="text-3xl md:text-5xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-299">
            Book a Consultation
          </h1>
          <p className="text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-300">
            Schedule a private session at our Alexandria studio for bespoke
            tailoring, bridal consultations, or a personalized styling
            experience.
          </p>
        </header>

        <form className="space-y-12" data-id="element-301">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-302">
            <div className="space-y-2" data-id="element-303">
              <label className="text-[10px] font-display tracking-widest uppercase text-black/40" data-id="element-304">
                Full Name
              </label>
              <input type="text" className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors" data-id="element-305" />
            </div>
            <div className="space-y-2" data-id="element-306">
              <label className="text-[10px] font-display tracking-widest uppercase text-black/40" data-id="element-307">
                Email Address
              </label>
              <input type="email" className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors" data-id="element-308" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-309">
            <div className="space-y-2" data-id="element-310">
              <label className="text-[10px] font-display tracking-widest uppercase text-black/40" data-id="element-311">
                Service Type
              </label>
              <select className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors bg-transparent appearance-none" data-id="element-312">
                <option data-id="element-313">Bespoke Tailoring</option>
                <option data-id="element-314">Bridal Consultation</option>
                <option data-id="element-315">Personal Styling</option>
                <option data-id="element-316">Collection Preview</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-317">
              <label className="text-[10px] font-display tracking-widest uppercase text-black/40" data-id="element-318">
                Preferred Date
              </label>
              <input type="date" className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors" data-id="element-319" />
            </div>
          </div>

          <div className="space-y-2" data-id="element-320">
            <label className="text-[10px] font-display tracking-widest uppercase text-black/40" data-id="element-321">
              Additional Notes
            </label>
            <textarea rows={4} className="w-full border-b border-grey-divider py-3 focus:outline-none focus:border-black transition-colors resize-none" data-id="element-322" />
          </div>

          <button className="w-full bg-black text-white py-5 text-[11px] font-display font-bold uppercase tracking-[0.3em] hover:bg-black/80 transition-colors" data-id="element-323">
            Request Appointment
          </button>
        </form>

        <div className="mt-16 pt-12 border-t border-grey-divider text-center" data-id="element-324">
          <p className="text-[10px] font-display tracking-widest uppercase text-black/40 mb-4" data-id="element-325">
            Direct Inquiries
          </p>
          <a href="tel:5718423307" className="text-lg font-display tracking-widest uppercase hover:opacity-50 transition-opacity" data-id="element-326">
            (571) 842-3307
          </a>
        </div>
      </div>
    </div>;
}